import { lazy } from 'react';
export const MyReportsLists = lazy(() => import(/* webpackChunkName: "my-reports-lists" */ '.'));
export default MyReportsLists;
